import { ROLLOUTS } from '@fiverr-private/listing_experiments';
import { useAppContext } from '../context/listingsContext';

export const useShouldShowAggregatedRating = (): boolean => {
    const { rollouts = {} } = useAppContext();

    return rollouts[ROLLOUTS.MEERKATS_LISTINGS_AGGREGATE_RATING] || false;
};
